<template>
  <b-modal
    size="xl"
    id="modal-newBallon"
    ref="modal-newBallon"
        :title="ballon ? 'Modifier ballon' : 'Nouveau ballon'"

    hide-footer
  >
    <b-container>
      <b-row align-h="center" class="mt-5 mb-5">
        <b-col cols="12">
          <b-card class="">
            <!-- <h3 class="mb-4">Login</h3> -->
            <b-form @submit.prevent="onSubmit">
               <b-card-header header-bg-variant="light">
              <b-row class="">
                <b-col>
                  <b-form-group
                    label="Type ballon*"
                    label-for="sort-by-select"
                    class="mb-0"
                  >
                    <b-form-select
                      v-model="form.typeId"
                      :options="types"
                      :select-size="types.length"
                      required
                    ></b-form-select>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group label="Référence*" label-for="exampleInput2">
                    <b-form-input
                      type="text"
                      v-model="form.ref"
                      required
                      placeholder="Référence"
                    >
                    </b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
               </b-card-header>

              <b-row class="mt-2">
                <b-col>
                  <b-form-group label="Marque" label-for="exampleInput1">
                    <b-form-input
                      id="exampleInput1"
                      type="text"
                      v-model="form.brand"
                      placeholder="Marque"
                    >
                    </b-form-input>
                  </b-form-group>
                  <b-form-group
                    id="exampleInputGroup2"
                    label="Type constante refroidissement"
                    label-for="exampleInput2"
                  >
                    <b-form-input
                      type="text"
                      v-model="form.typeConstanteRefroidissement"
                      placeholder="Type constante refroidissement"
                    >
                    </b-form-input>
                  </b-form-group>
                  <b-form-group
                    id="exampleInputGroup2"
                    label="Constante refroidissement"
                    label-for="exampleInput2"
                  >
                    <b-form-input
                      type="number"
                      v-model="form.constanteRefroidissement"
                      
                      placeholder="Constante refroidissement"
                    >
                    </b-form-input>
                  </b-form-group>
                  <b-form-group
                    id="exampleInputGroup2"
                    label="Description"
                    label-for="exampleInput2"
                  >
                    <b-form-textarea v-model="form.description" rows="2">
                    </b-form-textarea>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group
                    id="exampleInputGroup2"
                    label="Volume total*"
                    label-for="exampleInput2"
                  >
                    <b-form-input
                      type="number"
                      v-model="form.volumeTotal"
                      required
                      placeholder="Volume total"
                    >
                    </b-form-input>
                  </b-form-group>
                  <b-form-group
                    id="exampleInputGroup2"
                    label="Volume appoint*"
                    label-for="exampleInput2"
                  >
                    <b-form-input
                      type="number"
                      v-model="form.volumeAppoint"
                      required
                      placeholder="Volume appoint"
                    >
                    </b-form-input>
                  </b-form-group>
                  <b-form-group
                    id="exampleInputGroup2"
                    label="Diamètre (mm)*"
                    label-for="exampleInput2"
                  >
                    <b-form-input
                      type="number"
                      v-model="form.diameter"
                      required
                      placeholder="Diamètre (mm)"
                    >
                    </b-form-input>
                  </b-form-group>
                  <b-form-group
                    id="exampleInputGroup2"
                    label="Hauteur (mm)*"
                    label-for="exampleInput2"
                  >
                    <b-form-input
                      type="number"
                      v-model="form.height"
                      required
                      placeholder="Hauteur (mm)"
                    >
                    </b-form-input>
                  </b-form-group>
                  <b-form-group
                    id="exampleInputGroup2"
                    label="Isolant*"
                    label-for="exampleInput2"
                  >
                    <b-form-input
                      type="text"
                      v-model="form.isolant"
                      required
                      placeholder="Isolant"
                    >
                    </b-form-input>
                  </b-form-group>
                  <b-form-group
                    id="exampleInputGroup2"
                    label="Epaisseur (mm)*"
                    label-for="exampleInput2"
                  >
                    <b-form-input
                      type="number"
                      v-model="form.thickness"
                      required
                      placeholder="Epaisseur (mm)"
                    >
                    </b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <div>
                <b-button block type="submit" variant="primary">Valider</b-button
                >&nbsp;
              </div>
              <div class="mt-5 d-flex justify-content-center" v-if="isLoading">
                <b-spinner variant="success"></b-spinner>
              </div>
              <b-alert show v-if="message" dismissible :variant="variant"
                >{{ message }}
              </b-alert>
            </b-form>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </b-modal>
</template>

<script>
export default {
  name: "ModalCreateEditBallon",
  props: {
    ballon: Object,
  },
  data() {
    return {
      form: {},
      isLoading: false,
      edit: false,
      selected: "",
      message: "",
      types: [],
      variant: 'warning'
    };
  },
  created() {
    console.log(this.ballon);

    if (this.ballon) {
      this.form = this.ballon;
    }
    this.getTypesBallons();
  },
  methods: {
    getTypesBallons() {
      fetch(process.env.VUE_APP_API_BASE_URL + "/api/v1/component/getAll", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.localStorage.token}`
        },
      })
        .then((response) => response.json())
        .then((json) => {
          console.log(json);
          this.types = json.component
            .filter((item) => item.typeId === 2)
            .map((item) => ({
              value: item.id,
              text: item.name,
            }))
            .sort((a, b) => a.text.localeCompare(b.text));
        })
        .catch((err) => {
          console.log(err);
          this.token = false;
        });
    },
    async onSubmit() {
      this.isLoading = true;
      let res;
      if (this.ballon) {
        res = await fetch(
          `${process.env.VUE_APP_API_BASE_URL}/api/v1/ballon/updateBallon`,
          {
            method: "POST",
            body: JSON.stringify(this.form),
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.localStorage.token}`
            },
          }
        );
      } else {
        res = await fetch(
          `${process.env.VUE_APP_API_BASE_URL}/api/v1/ballon/saveBallon`,
          {
            method: "POST",
            body: JSON.stringify({ballon: this.form}),
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.localStorage.token}`
            },
          }
        );
      }

      const data = await res.json();
      // .then((data) => {
      console.log(data);
        this.message = data.message;
        if (data.erreur) {
          this.variant = 'danger'
        }

      this.isLoading = false;
      // })
      // .catch((err) => {
      //   this.isLoading = false;
      //   console.log(err);
      // });
    },
  },
};
</script>

<style></style>
